import { useEffect, useState } from 'react'
import { CustomizedModalProps } from 'components/bookings/modals/types'
import clsx from 'clsx'
import {
  Checkbox,
  Col,
  InputNumber,
  Label,
  Modal,
  Space,
} from 'components/common'

export interface BookingsUserMetaData {
  discount?: number
  limit?: number
  showDiscount?: boolean
}

export interface BookingsUserMetaDataProps
  extends Omit<CustomizedModalProps, 'onOk'> {
  userMetaData: BookingsUserMetaData
  /* eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any */
  showEligibleForExemption?: (value: any) => void
  onOk: (values: BookingsUserMetaData) => void
  onClose: (visible: boolean) => void
}

export const BookingsUserMetaDataEditModal = ({
  userMetaData,
  visible,
  onOk,
  onClose,
  showEligibleForExemption,
  ...rest
}: BookingsUserMetaDataProps): JSX.Element => {
  const [showDiscountOption, setDiscountOptions] = useState(false)
  const [limit, setLimit] = useState<number>(0)
  const [discount, setDiscount] = useState<number>(0)

  useEffect(() => {
    if (userMetaData) {
      setLimit(userMetaData?.limit)
      setDiscount(userMetaData?.discount)
      setDiscountOptions(userMetaData?.showDiscount)
    }
  }, [userMetaData])

  const onChangeDiscount = () => {
    setDiscountOptions((val) => !val)
  }
  const onSubmit = () => {
    const values = { limit: limit, discount: discount }
    onOk(values)
    onClose(false)
    showEligibleForExemption((val) => !val)
  }
  const onChangeInputLimit = (value: number) => {
    setLimit(value)
  }
  const onChangeInputDiscount = (value: number) => {
    setDiscount(value)
  }

  return (
    <Modal
      visible={visible}
      title={'減免対象を編集する'}
      okText={'保存する'}
      cancelText={'キャンセル'}
      onOk={() => {
        showDiscountOption && onSubmit()
      }}
      onCancel={() => onClose(false)}
      {...rest}
    >
      <Checkbox
        checked={showDiscountOption}
        onChange={onChangeDiscount}
        className={clsx('mb-10')}
      >
        減免対象
      </Checkbox>
      {showDiscountOption && (
        <Col span={24}>
          <Space>
            <div>
              <Label>減免残回数</Label>
              <InputNumber
                style={{ width: 200 }}
                min={0}
                max={64}
                maxLength={2}
                defaultValue={userMetaData?.limit ? userMetaData?.limit : 0}
                value={limit ? limit : 0}
                onChange={onChangeInputLimit}
              />
            </div>
            <div>
              <Label>減免付与回数</Label>
              <InputNumber
                style={{ width: 200 }}
                min={0}
                maxLength={8}
                defaultValue={
                  userMetaData?.discount ? userMetaData?.discount : 0
                }
                value={discount ? discount : 0}
                onChange={onChangeInputDiscount}
              />
            </div>
          </Space>
        </Col>
      )}
    </Modal>
  )
}
